import React from 'react';

import ConversationAssistantV2 from './components/ConversationAssistantV2';

import './style.scss';

// Leaving this mapping in place in case we need a ConversationAssistantV3 in the future.
const ConversationAssistant = () => <ConversationAssistantV2 />;

export default ConversationAssistant;
